<template>
  <div>
    <div class="d-flex flex-wrap align-center justify-space-between gap-2 mb-4">
      <h6 class="mb-0">Contas</h6>
      <div class="d-flex flex-wrap gap-2">
        <meta-signup-button
          :disabled="!canManage"
          @connected="onAccountsConnected"
        />
        <!-- <v-btn
          small
          outlined
          color="primary"
          :disabled="!canManage"
          @click="openCreate('ZAPI_WHATSAPP')"
        >
          <v-icon left small>mdi-whatsapp</v-icon>
          Adicionar ZAPI
        </v-btn>
        <v-btn
          small
          outlined
          color="primary"
          :disabled="!canManage"
          @click="openCreate('SMTP_EMAIL')"
        >
          <v-icon left small>mdi-email</v-icon>
          Adicionar E-mail
        </v-btn> -->
      </div>
    </div>

    <v-progress-linear v-if="loading" indeterminate color="primary" />
    <v-alert v-if="error" type="error" dense>{{ error }}</v-alert>
    <v-alert v-if="successMessage" type="success" dense>{{
      successMessage
    }}</v-alert>

    <v-alert
      v-if="!loading && !accounts.length && !error"
      type="info"
      text
      dense
    >
      Nenhuma conta cadastrada para esta empresa.
    </v-alert>

    <v-expansion-panels v-else-if="!loading" accordion>
      <v-expansion-panel v-for="account in accounts" :key="account.id">
        <v-expansion-panel-header>
          <div class="flex-grow-1">
            <div class="d-flex align-center flex-grow-1 gap-2 flex-wrap">
              <v-icon size="20">{{ typeMeta(account.type).icon }}</v-icon>
              <span class="font-weight-medium">
                {{ typeMeta(account.type).label }}
              </span>
            </div>
            <span class="text-body-2 text--secondary text-break">
              {{
                account.metadata?.displayPhoneNumber || account.integrationId
              }}
            </span>
          </div>
          <div class="d-flex align-center flex-wrap gap-1 mr-2 flex-grow-0">
            <v-chip v-if="account.platformId" x-small label outlined>
              {{ platforms[account.platformId]?.name || "Plataforma" }}
            </v-chip>
            <v-chip v-else x-small label outlined> Toda a empresa </v-chip>
            <v-chip
              v-if="account.webhookRedirectUrl"
              color="info"
              label
              x-small
            >
              Redirect ativo
            </v-chip>
            <v-chip
              v-if="
                account.type === 'META_WHATSAPP' && !isMetaRegistered(account)
              "
              color="warning"
              label
              x-small
            >
              Não registrado
            </v-chip>
            <v-chip
              v-else
              :color="account.active ? 'success' : 'error'"
              label
              x-small
            >
              {{ account.active ? "Ativa" : "Inativa" }}
            </v-chip>
            <v-chip v-if="templatesForAccount(account.id).length" x-small label>
              {{ templatesForAccount(account.id).length }} template(s)
            </v-chip>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <div class="d-flex justify-end gap-1 mb-3 pt-2">
            <v-btn
              small
              text
              color="error"
              :disabled="!canManage || !account.active"
              @click.stop="confirmDelete(account)"
            >
              <v-icon left small>mdi-power</v-icon>
              Desativar
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="
                account.type === 'META_WHATSAPP' && !isMetaRegistered(account)
              "
              small
              text
              color="primary"
              :disabled="!canManage"
              @click.stop="openRegister(account)"
            >
              <v-icon left small>mdi-cellphone-check</v-icon>
              Registrar número
            </v-btn>
            <v-btn
              v-if="account.type === 'META_WHATSAPP'"
              small
              text
              color="info"
              :disabled="!canManage"
              :loading="syncingAccountId === account.id"
              @click.stop="syncAccount(account)"
            >
              <v-icon left small>mdi-sync</v-icon>
              Sincronizar conta
            </v-btn>
            <v-btn
              v-if="account.type === 'META_WHATSAPP'"
              small
              text
              :disabled="!canManage"
              @click.stop="openMetaWebhookEdit(account)"
            >
              <v-icon left small>mdi-webhook</v-icon>
              Editar webhook
            </v-btn>
            <v-btn
              v-if="isManual(account.type)"
              small
              text
              :disabled="!canManage"
              @click.stop="openEdit(account)"
            >
              <v-icon left small>mdi-pencil</v-icon>
              Editar conta
            </v-btn>
          </div>

          <account-templates-table
            :account="account"
            :templates="templatesForAccount(account.id)"
            :template-types="templateTypes"
            :can-manage="canManage"
            :submitting-id="submittingId"
            :syncing-id="syncingId"
            @create="openCreateTemplate"
            @edit="openEditTemplate"
            @submit="submitTemplate"
            @sync-status="syncTemplateStatus"
            @delete="removeTemplate"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <meta-register-dialog
      v-model="registerDialog"
      :account="registerAccount"
      @registered="onAccountRegistered"
    />

    <account-form-dialog
      v-model="accountDialog"
      :type="formType"
      :account="editingAccount"
      :platforms="platformsList"
      @saved="loadAll"
    />

    <meta-account-edit-dialog
      v-model="metaWebhookDialog"
      :account="metaWebhookAccount"
      @saved="loadAll"
    />

    <template-form-dialog
      v-model="templateDialog"
      :template="editingTemplate"
      :accounts="accounts"
      :template-types="templateTypes"
      :default-account-id="defaultAccountId"
      @saved="loadAll"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MESSAGER from "@/services/admin/messager.js";
import MetaSignupButton from "./MetaSignupButton.vue";
import AccountFormDialog from "./AccountFormDialog.vue";
import MetaAccountEditDialog from "./MetaAccountEditDialog.vue";
import AccountTemplatesTable from "./AccountTemplatesTable.vue";
import MetaRegisterDialog from "./MetaRegisterDialog.vue";
import TemplateFormDialog from "./TemplateFormDialog.vue";

const TYPE_META = {
  META_WHATSAPP: { label: "WhatsApp (Meta)", icon: "mdi-whatsapp" },
  ZAPI_WHATSAPP: { label: "WhatsApp (ZAPI)", icon: "mdi-whatsapp" },
  SMTP_EMAIL: { label: "E-mail (SMTP)", icon: "mdi-email" },
};

export default {
  name: "AccountsList",
  components: {
    MetaSignupButton,
    AccountFormDialog,
    MetaAccountEditDialog,
    AccountTemplatesTable,
    MetaRegisterDialog,
    TemplateFormDialog,
  },
  data: () => ({
    loading: false,
    error: null,
    accounts: [],
    templates: [],
    templateTypes: [],
    platformsList: [],
    platforms: {},
    accountDialog: false,
    metaWebhookDialog: false,
    metaWebhookAccount: null,
    templateDialog: false,
    formType: "ZAPI_WHATSAPP",
    editingAccount: null,
    editingTemplate: null,
    defaultAccountId: null,
    submittingId: null,
    syncingId: null,
    syncingAccountId: null,
    successMessage: null,
    registerDialog: false,
    registerAccount: null,
  }),
  computed: {
    ...mapGetters("auth", ["hasPermission"]),
    ...mapGetters("company", ["selectedCompany"]),
    canManage() {
      return this.hasPermission(8192);
    },
  },
  methods: {
    typeMeta(type) {
      return TYPE_META[type] || { label: type, icon: "mdi-help-circle" };
    },
    isManual(type) {
      return type === "ZAPI_WHATSAPP" || type === "SMTP_EMAIL";
    },
    templatesForAccount(accountId) {
      return this.templates.filter((t) => t.accountId === accountId);
    },
    async loadCatalog() {
      const data = await MESSAGER.getCatalog();
      this.templateTypes = data.templateTypes || [];
    },
    async loadAll() {
      try {
        this.loading = true;
        this.error = null;
        const [accountsData, templatesData] = await Promise.all([
          MESSAGER.accounts.getAll(),
          MESSAGER.templates.getAll(),
        ]);
        this.accounts = accountsData.accounts || [];
        this.platformsList = accountsData.platforms || [];
        this.platforms = Object.fromEntries(
          this.platformsList.map((p) => [p.id, p])
        );
        this.templates = templatesData.templates || [];
      } catch (error) {
        this.error = error.message || "Erro ao carregar dados";
      } finally {
        this.loading = false;
      }
    },
    openCreate(type) {
      this.formType = type;
      this.editingAccount = null;
      this.accountDialog = true;
    },
    openEdit(account) {
      this.formType = account.type;
      this.editingAccount = account;
      this.accountDialog = true;
    },
    openMetaWebhookEdit(account) {
      this.metaWebhookAccount = account;
      this.metaWebhookDialog = true;
    },
    openCreateTemplate(account) {
      this.editingTemplate = null;
      this.defaultAccountId = account.id;
      this.templateDialog = true;
    },
    openEditTemplate(template) {
      this.editingTemplate = template;
      this.defaultAccountId = null;
      this.templateDialog = true;
    },
    onAccountsConnected() {
      this.loadAll();
    },
    async submitTemplate(template) {
      try {
        this.submittingId = template.id;
        await MESSAGER.templates.submit(template.id);
        await this.loadAll();
      } catch (error) {
        this.error = error.message || "Erro ao submeter template";
      } finally {
        this.submittingId = null;
      }
    },
    isMetaRegistered(account) {
      return account?.metadata?.registered === true;
    },
    openRegister(account) {
      this.registerAccount = account;
      this.registerDialog = true;
    },
    onAccountRegistered() {
      this.successMessage = "Número registrado na Meta com sucesso.";
      this.loadAll();
    },
    async syncAccount(account) {
      try {
        this.syncingAccountId = account.id;
        this.error = null;
        this.successMessage = null;
        const data = await MESSAGER.accounts.syncTemplates(account.id);
        const s = data.summary || {};
        const parts = [];
        if (s.imported) parts.push(`${s.imported} importado(s)`);
        if (s.updated) parts.push(`${s.updated} atualizado(s)`);
        if (s.createdDraft)
          parts.push(`${s.createdDraft} rascunho(s) criado(s)`);
        if (s.skipped) parts.push(`${s.skipped} sem alteração`);
        this.successMessage = parts.length
          ? `Sincronização concluída: ${parts.join(", ")}.`
          : "Sincronização concluída.";
        await this.loadAll();
      } catch (error) {
        this.error = error.message || "Erro ao sincronizar conta";
      } finally {
        this.syncingAccountId = null;
      }
    },
    async syncTemplateStatus(template) {
      try {
        this.syncingId = template.id;
        this.error = null;
        await MESSAGER.templates.syncStatus(template.id);
        await this.loadAll();
      } catch (error) {
        this.error = error.message || "Erro ao atualizar status do template";
      } finally {
        this.syncingId = null;
      }
    },
    async removeTemplate(template) {
      const ok = window.confirm("Deseja remover este template?");
      if (!ok) return;
      try {
        this.loading = true;
        await MESSAGER.templates.delete(template.id);
        await this.loadAll();
      } catch (error) {
        this.error = error.message || "Erro ao remover template";
      } finally {
        this.loading = false;
      }
    },
    async confirmDelete(account) {
      const ok = window.confirm(
        "Deseja desativar esta conta? O número será desconectado (deregistrado) na Meta e a conta deixará de ser usada pelo motor de despacho. Os templates do WhatsApp Business (WABA) serão mantidos. Você poderá reconectar depois."
      );
      if (!ok) return;
      try {
        this.loading = true;
        await MESSAGER.accounts.delete(account.id);
        await this.loadAll();
      } catch (error) {
        this.error = error.message || "Erro ao desativar conta";
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    "selectedCompany.id"() {
      this.loadAll();
    },
    templateDialog(open) {
      if (!open) this.defaultAccountId = null;
    },
  },
  async mounted() {
    await this.loadCatalog();
    await this.loadAll();
  },
};
</script>

<style scoped>
.gap-1 {
  gap: 4px;
}
.gap-2 {
  gap: 8px;
}
</style>
